// Single source of truth for the reCAPTCHA site key, client side.
//
// The key is NOT secret -- it ships in the HTML on every page load and Google
// publishes theirs in their own docs. The point of centralising it is not
// secrecy, it is that it used to be hardcoded in three separate components,
// so rotating it meant finding all three and rebuilding the frontend.
//
// Now: app.js injects it into <meta name="recaptcha-sitekey"> at request time
// from config.recaptcha.sitekey. Rotating either key is "edit config.js,
// pm2 restart app" -- no rebuild, which matters because this project's build
// toolchain (CRA 3.3 / webpack 4) is the fragile part of the stack.
//
// The matching SECRET stays server-side in config.js and must never reach the
// browser. Both are 40 chars starting with "6L", so they are easy to confuse:
// if the widget renders but verification always fails, they are swapped.

export function getRecaptchaSiteKey() {
  if (typeof document !== 'undefined') {
    const meta = document.querySelector('meta[name="recaptcha-sitekey"]');
    const injected = meta && meta.getAttribute('content');
    if (injected) {
      return injected;
    }
  }
  // Local dev: the CRA dev server serves public/index.html unmodified, so the
  // meta tag is still the empty placeholder. Put a key in .env.local as
  // REACT_APP_RECAPTCHA_SITEKEY, or use Google's always-pass test pair:
  //   site   6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI
  //   secret 6LeIxAcTAAAAAGG-vFI1TnRWxMZNFuojJ4WifJWe
  return process.env.REACT_APP_RECAPTCHA_SITEKEY || '';
}

export default getRecaptchaSiteKey;
